let forms = {
   login: {
      icon: 'fa fa-user',
      title: 'Log In',
      subtitle: 'Log In to the System',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'custom-input col-12', model: 'email',
            validation: 'required|min:3|max:150|email', label: 'Email Address'
         },
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'password',
            validation: 'required|min:3|max:150', label: 'Password'
         },
      ],
   },
}

module.exports = {
   forms: utils.generateAllFormData(forms),
}